import { styled, Grid, Box } from '@mui/material';
import { Typography } from '@totalsoft/rocket-ui';

export const FinancialProductRuleCardContent = styled(Grid, { shouldForwardProp: prop => !['colors'].includes(prop) })(
  ({ theme, colors }) => ({
    position: 'relative',
    padding: theme.spacing(2),
    background: `linear-gradient(to right, #FFF 50%, ${
      colors.offerColor
        ? colors.offerColor
        : colors.folderColor
        ? colors.folderColor
        : colors.facilityColor
        ? colors.facilityColor
        : '#EEEEEE'
    } 90%)`,
    '&:hover': {
      background: `linear-gradient(to right, #FFF 100%, ${
        colors.offerColor
          ? colors.offerColor
          : colors.folderColor
          ? colors.folderColor
          : colors.facilityColor
          ? colors.facilityColor
          : '#EEEEEE'
      } 0%) !important`
    }
  })
);

export const FinancialProductRulesListWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%'
}));

export const FinancialProductRuleListWrapper = styled(Grid)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(2),
  height: '100%'
}));

export const TypographyPaddingRight5 = styled(Typography)(() => ({
  paddingRight: '5px'
}));

export const TypographyWordWrap = styled(Typography)(() => ({
  wordWrap: 'break-word'
}));

export const TypographyMax4Rows = styled(Typography)(() => ({
  overflow: 'hidden',
  display: '-webkit-box',
  '-webkit-line-clamp': '4',
  '-webkit-box-orient': 'vertical'
}));

export const GridFullSize = styled(Grid)(() => ({
  height: '100%',
  width: '100%'
}));

export const GridFullSizePadding5 = styled(GridFullSize)(() => ({
  paddingRight: '5px'
}));
